/**
 * Wie mag beoordelingen verwijderen op het teamdashboard?
 *
 * Expliciete lijst met weigerende default. De eerdere vergelijking
 * (`role !== 'medewerker'`) gaf de verwijderknop aan élke onbekende rol —
 * bijvoorbeeld `editor` uit de gedeelde rollentabel — waarna de server
 * weigerde en de gebruiker werd uitgelogd.
 *
 * Spec: _bmad-output/implementation-artifacts/spec-fix-rolbepaling-app-scope.md, punt 4.
 */
import { isKnownHrRole } from '@functieloonhuis/shared';

const CAN_DELETE_EVALUATIONS = ['admin', 'hr', 'beoordelaar'] as const;

export function canDeleteEvaluationsFor(role: string | null | undefined): boolean {
  if (!isKnownHrRole(role)) return false;
  return (CAN_DELETE_EVALUATIONS as readonly string[]).includes(role);
}
